require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;


//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/core-js/library/fn/object/assign.js
// module id = 351
// module chunks = 0